<script>
	import UserOrder from './UserOrder.svelte';
	import { orders, ordersToShow } from '../store';
	import { smartWalletCreationPending, walletConnected, walletLoaded } from '$lib/wallet/store';
	import { smartContractWalletAddress } from '../scwallet/store';
	import { getParsedError } from '$lib/web3/errorHandling';
	import {
		addErrorNotification,
		addTransactionNotification
	} from '$lib/notifications/notificationManager';
	import { cancelAllOrdersSmartContract } from '$lib/web3/actions/tradeLimit';
	import { cancellingAllOrders } from '../userInteract/store';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';

	async function cancelAllOrders() {
		try {
			cancellingAllOrders.set(true);
			const ordersId = $ordersToShow.map((order) => order.orderId.toString());
			let tx = await cancelAllOrdersSmartContract(ordersId, $smartContractWalletAddress);
			addTransactionNotification('Orders Cancelled', 'Your orders have been cancelled.', tx);
		} catch (e) {
			const { title, description } = getParsedError(e);
			addErrorNotification(title, description, JSON.stringify(e));
		} finally {
			cancellingAllOrders.set(false);
		}
	}
</script>

{#if $ordersToShow && $ordersToShow.length > 0}
	<div class="hidden sm:grid grid-cols-8 pl-2 text-fx-grey-400 pb-6">
		<div class="text-xs">Perp</div>
		<div class="text-xs text-center">Side</div>
		<div class="text-xs text-center">Size/Amount</div>
		<div class="text-xs text-center">Order Type</div>
		<div class="text-xs text-center">Execution Price</div>
		<div class="text-xs text-center">TP/SL</div>
		<div class="text-xs text-center">Status</div>
		<div class="text-xs text-right">
			<div>
				{#if $cancellingAllOrders}
					<div class="flex justify-end mr-6">
						<ProcessingIcon />
					</div>
				{:else}
					<button
						class="underline rounded-md text-center px-2 py-1 text-md text-fx-yellow"
						on:click={cancelAllOrders}
					>
						Cancel All
					</button>
				{/if}
			</div>
		</div>
	</div>
{/if}
<div class="overflow-auto sm:max-h-[45vh]">
	{#if $walletLoaded && $walletConnected && $orders.loading && $smartContractWalletAddress}
		<div class="grid gap-2">
			<div
				class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
			/>
			<div
				class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
			/>
			<div
				class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
			/>
		</div>
	{:else if $ordersToShow && $ordersToShow.length > 0}
		<div class="flex flex-col overflow-y">
			{#each $ordersToShow as eachOrder}
				<UserOrder ord={eachOrder} />
			{/each}
		</div>
	{:else}
		<div class="py-20 sm:py-10 flex flex-col items-center justify-center">
			{#if $walletLoaded && $walletConnected && $smartContractWalletAddress}
				<img loading="lazy" src={'empty-position.png'} alt="" class="mx-auto max-w-[30%] mb-3" />
				<div class="text-center text-fx-grey-200 font-medium text-sm mb-2">No Orders Found</div>
				<div class="w-full text-fx-grey-400 text-xs rounded-xl squircle-xl text-center">
					Once you place an order, the open orders will appear here before being filled.
				</div>
			{:else if $walletLoaded && !$walletConnected}
				<img loading="lazy" src={'empty-position.png'} alt="" class="mx-auto max-w-[30%] mb-3" />
				<div class="text-center text-fx-grey-200 font-medium text-sm mb-2">Connect wallet</div>
				<div class="w-full text-fx-grey-400 text-xs rounded-xl squircle-xl text-center">
					Once you place an order, the open orders will appear here before being filled.
				</div>
			{:else if $smartWalletCreationPending}
				<img loading="lazy" src={'empty-position.png'} alt="" class="mx-auto max-w-[30%] mb-3" />
				<div class="text-center text-fx-grey-200 font-medium text-sm mb-2">
					Create Smart Contract Wallet
				</div>
				<div class="w-full text-fx-grey-400 text-xs rounded-xl squircle-xl text-center">
					Once you place an order, the open orders will appear here before being filled.
				</div>
			{:else}
				<div class="grid gap-2">
					<div
						class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
					/>
					<div
						class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
					/>
					<div
						class="w-full h-12 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
					/>
				</div>
			{/if}
		</div>
	{/if}
</div>
